module.exports = {
  AUTHENTICATION: 'authentication',
  PAYIN: 'payin',
  PAYOUT: 'payout',
  RISK_ASSESSMENT: 'risk_assessment',
};
